import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Brand from "@components/Brand";
import styles from "./index.less";

function Footer(props) {
  // console.log('Footer props', props)
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("home");
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  if (`/${current}` !== pathname) {
    setCurrent(pathname.replace("/", ""));
  }

  return (
    <div className={styles["footer"]}>
      <div className={styles["footer-main"]}>
        <div className={styles["row"]}>
          <div className={styles["col-left"]}>
            <Brand />
          </div>
        </div>
        <div className={styles["row"]}>
          <div className={styles["col-left"]}>
            <div>电话：027-81708231</div>
            <div>邮箱：funorange@fun.tv</div>
            <div>
              地址：武汉市东湖新技术开发区金融港一路7号神州数码武汉科技园17栋1-4层01室
            </div>
          </div>
          <div className={styles["col-right"]}>
            <div>
              <a href="https://www.12377.cn/" target="_blank" rel="noreferrer">
                违法和不良信息举报中心
              </a>
            </div>
            <div>
              <a
                href="https://jbts.mct.gov.cn/"
                target="_blank"
                rel="noreferrer"
              >
                全国文化市场举报平台
              </a>
            </div>
          </div>
        </div>
        <div className={styles["row"]}>
          <div className={styles["col"]}>
            <div>
              Copyright 2022 武汉风行在线技术有限公司 ALL Rights Reserved{" "}
              网站备案号：
              <a
                href="https://beian.miit.gov.cn"
                target="_blank"
                rel="noreferrer"
              >
                鄂ICP备2021022285号-1
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
